export enum TypeEnum {
  Input = "input",
  Dropdown = "dropdown",
  Multiselect = "multiselect",
  Switch = "Switch",
  Description = "Description",
  FileUpload = "FileUpload",
  Config = "Config",
}
